import { type AtomEffect, atom, selector } from 'recoil';
import { getCookie } from '../../services/utils/cookieUtil';

const shouldCoverCriticalIllnessEffect: AtomEffect<boolean> = ({ onSet }) => {
    const domain = window.location.hostname?.split('.').slice(-2).join('.');
    onSet((shouldCover) => {
        document.cookie = `shouldCoverCriticalIllness=${shouldCover.toString()};Domain=${domain}`;
    });
};

const shouldCoverCriticalIllnessSelector = selector<boolean>({
    key: 'shouldCoverCriticalIllnessSelector',
    get: () => {
        return getCookie('shouldCoverCriticalIllness') === 'true';
    }
});

export const shouldCoverCriticalIllnessAtom = atom<boolean>({
    key: 'shouldCoverCriticalIllness',
    default: shouldCoverCriticalIllnessSelector,
    effects: [shouldCoverCriticalIllnessEffect]
});
